import React from "react";
import { DragAndDrop } from "../../../../../components";

const DragAndDropList = () => {
  const handleChange = (keywords, connectors, keywordString) => {
    //console.log("data:", keywords, connectors, keywordString);
  };

  return (
    <div className="my-5">
      <DragAndDrop onChange={handleChange} title="Keywords" data />

      <hr className="my-8 text-gray-200" />

      <DragAndDrop
        onChange={handleChange}
        title="Keywords Prefilled"
        data={[
          {
            keyword: "Java ",
            connector: "",
          },
          {
            keyword: "Python",
            connector: "AND",
          },
          {
            keyword: "React",
            connector: "OR",
          },
          {
            keyword: ".NET",
            connector: "NOT",
          },
        ]}
      />
    </div>
  );
};

export default DragAndDropList;
